import React, { Component } from "react";
import {
  GET,
  PUT,
  loading,
  NavbarAdmin,
  Modal,
  DatePicker,
  Select,
  t // นำเข้าฟังก์ชัน t
} from "../../components/CustomComponent.js";

const TECHNICIAN_COLORS = ["#198754", "#fd7e14", "#0d6efd", "#6f42c1", "#d63384", "#0d6efd", "#6c757d"];

export default class Scheduling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      technicians: [],
      scheduleDays: [],
      unassignedJobs: [],
      workOrders: [],
      showAllUnassigned: false,
      weekStartDate: this.getWeekStart(new Date()),
      modalEditOpen: false,
      editingJob: null,
      editStartDate: "",
      editTechnicianUid: "",
    };
  }

  async componentDidMount() {
    await this.fetchSchedulingData();
  }

  getDatePart = (dateTime) => {
    if (!dateTime) return "";
    const value = String(dateTime).trim();
    if (value.includes("T")) return value.split("T")[0];
    if (value.includes(" ")) return value.split(" ")[0];
    return value;
  };

  getTimePart = (dateTime) => {
    if (!dateTime) return "";
    const value = String(dateTime).trim();
    let timePart = "";

    if (value.includes("T")) {
      timePart = value.split("T")[1] || "";
    } else if (value.includes(" ")) {
      timePart = value.split(" ")[1] || "";
    }

    if (!timePart) return "";
    timePart = timePart.split("Z")[0].split("+")[0].split("-")[0].trim();
    const [hours = "00", minutes = "00", seconds = "00"] = timePart.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:${seconds.padStart(2, "0")}`;
  };

  openEditModal = (job) => {
    if (!job) return;
    const editStartDate = job.fullDate || this.getDatePart(job.start_date) || "";
    this.setState({
      modalEditOpen: true,
      editingJob: job,
      editStartDate,
      editTechnicianUid: job.technicianUid || "",
    });
  };

  closeEditModal = () => {
    this.setState({
      modalEditOpen: false,
      editingJob: null,
      editStartDate: "",
      editTechnicianUid: "",
    });
  };

  saveEditModal = async () => {
    const { editingJob, editTechnicianUid, editStartDate } = this.state;
    if (!editingJob || !editingJob.workOrderUid || !editingJob.visitUid) return;
    if (!editTechnicianUid) return;

    loading(true);
    try {
      const result = await this.updateWorkOrderVisitAssignment(
        editingJob.workOrderUid,
        editingJob.visitUid,
        editTechnicianUid,
        editStartDate,
        true
      );

      if (!result?.status) {
        console.error("Failed to update work order visit", result?.message);
        return;
      }

      await this.fetchSchedulingData();
      this.closeEditModal();
    } finally {
      loading(false);
    }
  };

  fetchSchedulingData = async () => {
    loading(true);
    const scheduleDays = this.getScheduleDays(this.state.weekStartDate);
    // console.log("scheduleDays:",scheduleDays)
    const [techResult, woResult] = await Promise.all([
      GET("admin/technicians", {
        page: 1,
        page_size: 10,
        uid: "",
        type: "",
        data_search: "",
      }),
      GET("admin/work-orders", {
        page: 1,
        page_size: 20,
        uid: "",
        data_search: "",
      }),
    ]);

    const technicians = techResult?.status && Array.isArray(techResult.data) ? techResult.data : [];
    const workOrders = woResult?.status && Array.isArray(woResult.data) ? woResult.data : [];

    const { mappedTechnicians, unassignedJobs } = this.buildSchedule(technicians, workOrders, scheduleDays);

    this.setState({
      technicians: mappedTechnicians,
      scheduleDays,
      unassignedJobs,
      workOrders: workOrders,
    });

    loading(false);
  };

  handleDragStart = (event, job) => {
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("application/json", JSON.stringify(job));
  };

  handleDragOver = (event) => {
    event.preventDefault();
  };

  handleDrop = async (event, technicianUid, dateKey, targetFullDate) => {
    event.preventDefault();
    event.stopPropagation();
    const payload = event.dataTransfer.getData("application/json");
    if (!payload) return;

    let job;
    try {
      job = JSON.parse(payload);
    } catch (err) {
      return;
    }

    if (!job || !job.workOrderUid || !job.visitUid) return;

    loading(true);
    let result;
    try {
      result = await this.updateWorkOrderVisitAssignment(job.workOrderUid, job.visitUid, technicianUid, targetFullDate);
    } catch (err) {
      console.error("Failed to assign technician to work order visit", err);
      return;
    } finally {
      loading(false);
    }

    if (!result?.status) {
      console.error("Failed to assign technician to work order visit", result?.message);
      event.dataTransfer.clearData("application/json");
      return;
    }

    this.setState((prevState) => {
      const updatedTechnicians = prevState.technicians.map((tech) => {
        if (tech.uid !== technicianUid) return tech;

        const scheduleItem = {
          ...job,
          technicianUid,
          technicianName: tech.name,
          customColor: job.priorityBg,
          customTextColor: job.priorityColor,
          fullDate: dateKey,
          start_date: this.combineDateAndTime(job.start_date, targetFullDate),
          end_date: this.combineDateAndTime(job.end_date, targetFullDate),
          time: this.formatTime(this.combineDateAndTime(job.start_date, targetFullDate)),
        };

        return {
          ...tech,
          schedule: {
            ...tech.schedule,
            [dateKey]: [...(tech.schedule[dateKey] || []), scheduleItem],
          },
        };
      });

      const updatedUnassigned = prevState.unassignedJobs.filter((item) => item.visitUid !== job.visitUid || item.workOrderUid !== job.workOrderUid);

      return {
        technicians: updatedTechnicians,
        unassignedJobs: updatedUnassigned,
      };
    });
  };

  toggleUnassignedView = () => {
    this.setState((prevState) => ({
      showAllUnassigned: !prevState.showAllUnassigned,
    }));
  };

  changeWeek = (weekOffset) => {
    const newStart = new Date(this.state.weekStartDate);
    newStart.setDate(newStart.getDate() + weekOffset * 7);
    const scheduleDays = this.getScheduleDays(newStart);
    this.setState({ weekStartDate: newStart, scheduleDays });
  };

  showCurrentWeek = () => {
    const today = new Date();
    const startOfWeek = this.getWeekStart(today);
    const scheduleDays = this.getScheduleDays(startOfWeek);
    this.setState({ weekStartDate: startOfWeek, scheduleDays });
  };

  formatWeekRange = (startDate) => {
    if (!startDate) return "";
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    const options = { month: "short", day: "numeric" };
    const startLabel = startDate.toLocaleDateString("en-US", options);
    const endLabel = endDate.toLocaleDateString("en-US", options);
    return `${startLabel} - ${endLabel}`;
  };

  getWeekStart = (date) => {
    const result = new Date(date);
    const dayIndex = result.getDay();
    result.setDate(result.getDate() - dayIndex);
    result.setHours(0, 0, 0, 0);
    return result;
  };

  updateWorkOrderVisitAssignment = async (workOrderUid, visitUid, technicianUid, targetFullDate, replaceTechnician = false) => {
    const workOrder = (this.state.workOrders || []).find((item) => item.uid === workOrderUid);
    if (!workOrder) {
      return { status: false, message: "Work order not found" };
    }

    const body = this.buildWorkOrderUpdatePayload(workOrder, visitUid, technicianUid, targetFullDate, replaceTechnician);
    return await PUT(`admin/work-orders/${workOrderUid}`, body);
  };

  combineDateAndTime = (dateString, targetFullDate) => {
    if (!dateString || !targetFullDate) return dateString;

    const timePart = this.getTimePart(dateString);
    return `${targetFullDate} ${timePart || "00:00:00"}`;
  };

  buildWorkOrderUpdatePayload = (workOrder, visitUid, technicianUid, targetFullDate, replaceTechnician = false) => {
    const visits = Array.isArray(workOrder.visits) ? workOrder.visits : [];

    const updatedVisits = visits.map((visit, index) => {
      const currentTechnicianUids = (Array.isArray(visit.visits_technicians) ? visit.visits_technicians : [])
        .map((technician) => technician?.technician?.uid || technician)
        .filter(Boolean);

      const visitsTechnicians = visit.uid === visitUid
        ? replaceTechnician
          ? [technicianUid]
          : Array.from(new Set([...currentTechnicianUids, technicianUid]))
        : currentTechnicianUids;

      const startDate = visit.uid === visitUid
        ? this.combineDateAndTime(visit.start_date, targetFullDate)
        : visit.start_date;

      const endDate = visit.uid === visitUid
        ? this.combineDateAndTime(visit.end_date, targetFullDate)
        : visit.end_date;

      return {
        uid: visit.uid,
        sequence: visit.sequence || index + 1,
        start_date: startDate,
        end_date: endDate,
        visits_technicians: visitsTechnicians,
      };
    });

    return {
      // ...workOrder,
      visits: updatedVisits,
    };
  };

  getScheduleDays = (startDate) => {
    const reference = startDate ? new Date(startDate) : new Date();
    const weekdayKeys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    return Array.from({ length: 7 }).map((_, offset) => {
      const date = new Date(reference);
      date.setDate(reference.getDate() + offset);
      const dayKey = weekdayKeys[date.getDay()];
      const isWeekend = date.getDay() === 0 || date.getDay() === 6;
      const localFullDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      return {
        day: t(dayKey),
        date: `${date.getDate()}`,
        fullDate: localFullDate,
        sub: offset === 0 ? t("today") : isWeekend ? t("weekend") : "",
        isToday: offset === 0,
        isWeekend,
      };
    });
  };

  getTechnicianName = (tech) => {
    const nameParts = [tech.perfix_name, tech.first_name_th, tech.last_name_th].filter(Boolean);
    if (nameParts.length) return nameParts.join(" ");
    return tech.technician_code || "Tech";
  };

  getTechnicianInitials = (name) => {
    if (!name) return "--";
    const parts = name.split(" ").filter(Boolean);
    if (parts.length >= 2) return `${parts[0].charAt(0)}${parts[1].charAt(0)}`;
    return name.slice(0, 2).toUpperCase();
  };

  formatDateKey = (dateString) => {
    if (!dateString) return "";
    return this.getDatePart(dateString);
  };

  formatTime = (dateString) => {
    if (!dateString) return "";
    const time = this.getTimePart(dateString);
    if (!time) return "";
    const [hours = "00", minutes = "00"] = time.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
  };

  buildSchedule = (technicians, workOrders, scheduleDays) => {
    const techMap = new Map();
    const mappedTechnicians = technicians.map((tech, index) => {
      const name = this.getTechnicianName(tech);
      const initials = this.getTechnicianInitials(name);
      const skillLabels = Array.isArray(tech.technician_skill)
        ? tech.technician_skill.map((skill) => skill.level).filter(Boolean).join(", ")
        : "";

      const mappedTech = {
        uid: tech.uid,
        technician_code: tech.technician_code,
        name,
        skills: skillLabels || t("no_skill"),
        initials,
        bg: TECHNICIAN_COLORS[index % TECHNICIAN_COLORS.length],
        jobsCount: `0 ${t("jobs")}`,
        utilBg: "#e0ebff",
        utilText: "0%",
        utilColor: "#0d6efd",
        schedule: {},
        isLeave: !tech.is_active,
        leaveText: t("on_leave"),
        leaveDate: `${t("annual_leave")}: ${t("not_available")}`,
      };

      techMap.set(tech.uid, mappedTech);
      return mappedTech;
    });

    const unassignedJobs = [];

    workOrders.forEach((workOrder) => {
      const customerName =
        workOrder.customer?.full_name_th ||
        workOrder.customer?.full_name_en ||
        workOrder.customer?.alias_name ||
        t("customer");

      const title =
        workOrder.asset?.part?.name ||
        workOrder.category?.name_th ||
        workOrder.service_type?.name_th ||
        workOrder.wo_number ||
        workOrder.wr_number ||
        t("work_order");

      const priority = workOrder.priority?.name_th || workOrder.priority?.name_en || t("priority");
      const sla = workOrder.priority?.sla_response_time_start
        ? `${t("sla")}: ${workOrder.priority.sla_response_time_start} ${workOrder.priority.sla_response_time_start_unit || "h"}`
        : `${t("sla")}: -`;

      (workOrder.visits || []).forEach((visit) => {
        const dateKey = this.formatDateKey(visit.start_date);
        const time = this.formatTime(visit.start_date);
        const job = {
          workOrderUid: workOrder.uid,
          visitUid: visit.uid,
          id: workOrder.wo_number || workOrder.wr_number,
          priority,
          priorityBg: workOrder.priority?.background_color || "#fff0e0",
          priorityColor: workOrder.priority?.font_color || "#000000",
          title,
          customer: customerName,
          sla,
          distance: workOrder.asset?.asset_code || "-",
          slaColor: workOrder.priority?.font_color || undefined,
          time,
          start_date: visit.start_date,
          end_date: visit.end_date,
          fullDate: dateKey,
        };

        if (!Array.isArray(visit.visits_technicians) || visit.visits_technicians.length === 0) {
          unassignedJobs.push(job);
          return;
        }

        visit.visits_technicians.forEach((visitTech) => {
          const techUid = visitTech?.technician?.uid;
          const tech = techMap.get(techUid);
          if (!tech) return;
          const scheduleItem = {
            ...job,
            technicianUid: techUid,
            technicianName: tech.name,
            customColor: job.priorityBg,
            customTextColor: job.priorityColor,
          };
          tech.schedule[dateKey] = tech.schedule[dateKey] || [];
          tech.schedule[dateKey].push(scheduleItem);
        });
      });
    });

    mappedTechnicians.forEach((tech) => {
      const count = Object.values(tech.schedule).flat().length;
      tech.jobsCount = `${count} ${t("jobs")}`;
      tech.utilText = `${Math.min(100, count * 20)}%`;
    });

    return { mappedTechnicians, unassignedJobs };
  };

  render() {
    const { technicians, scheduleDays, unassignedJobs, showAllUnassigned, weekStartDate } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1">{t("scheduling_dispatch")}</h3>
                        <div className="text-secondary">{t("manage_tech_schedules")}</div>
                    </div>
                    <div className="d-flex gap-3 align-items-center">
                        <div className="d-flex align-items-center bg-white border rounded-3 px-2 py-1 shadow-sm">
                            <button className="btn btn-sm btn-white border-0 text-secondary" onClick={() => this.changeWeek(-1)}>
                                <span className="icon">{"\uf053"}</span>
                            </button>
                            <div className="fw-bold text-dark px-3 text-14">{this.formatWeekRange(weekStartDate)}</div>
                            <button className="btn btn-sm btn-white border-0 text-secondary" onClick={() => this.changeWeek(1)}>
                                <span className="icon">{"\uf054"}</span>
                            </button>
                        </div>

                        <button className="btn btn-white bg-white border shadow-sm px-3 fw-bold rounded-3 text-dark d-flex align-items-center" onClick={this.showCurrentWeek}>
                            <span className="icon me-2 text-secondary">{"\uf073"}</span> {t("today")}
                        </button>

                        {/* <button className="btn btn-primary fw-bold px-3 rounded-3 shadow-sm d-flex align-items-center">
                <span className="icon me-2">{"\uf044"}</span> {t("ai_suggest")}
              </button> */}
                    </div>
                </div>

                {/* Unassigned Jobs Section */}
                <div className="bg-white rounded-4 shadow-sm p-3 mb-4 border border-light">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold mb-0 d-flex align-items-center text-dark">
                            <span className="icon text-warning me-2 text-18">{"\uf187"}</span> {t("unassigned_jobs")}
                            <span className="badge bg-warning text-dark rounded-pill ms-2 px-2">{unassignedJobs.length}</span>
                        </h6>
                        <button type="button" className="btn btn-link p-0 text-primary text-decoration-none fw-bold text-14" onClick={this.toggleUnassignedView}>
                            {showAllUnassigned ? t("hide_all") : t("view_all")}
                        </button>
                    </div>

                    <div
                        className="d-flex gap-3 overflow-auto pb-2"
                        style={{
                            whiteSpace: showAllUnassigned ? "normal" : "nowrap",
                            flexWrap: showAllUnassigned ? "wrap" : "nowrap",
                        }}
                    >
                        {(showAllUnassigned ? unassignedJobs : unassignedJobs).map((job, idx) => (
                            <div
                                key={idx}
                                draggable
                                onClick={() => this.openEditModal(job)}
                                onDragStart={(event) => this.handleDragStart(event, job)}
                                className="border-secondary rounded-3 shadow-none p-3"
                                style={{ cursor: "pointer", minWidth: "260px", borderStyle: "dashed !important", borderColor: "#dee2e6" }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-primary fw-bold text-12">{job.id}</span>
                                    <span className="badge rounded-pill fw-bold text-10 px-2 py-1" style={{ backgroundColor: job.priorityBg, color: job.priorityColor }}>
                                        {job.priority}
                                    </span>
                                </div>
                                <div className="fw-bold text-dark text-14 text-truncate">{job.title}</div>
                                <div className="text-secondary text-12 mb-3 text-truncate">{job.customer}</div>
                                <div className="d-flex justify-content-between text-12 text-secondary">
                                    <div className="d-flex align-items-center" style={{ color: job.slaColor || "inherit" }}>
                                        <span className="icon me-1">{"\uf017"}</span> {job.sla}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center text-12 text-secondary">
                                    <span className="icon me-1">{"\uf041"}</span> {job.distance}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <Modal size="md" show={this.state.modalEditOpen} onHide={this.closeEditModal} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg bg-light">
                    <Modal.Header className="bg-white border-bottom px-4 py-3 d-flex justify-content-between align-items-center" closeButton>
                        <h5 className="mb-0">{t("update_work_order")}</h5>
                    </Modal.Header>
                    <Modal.Body className="p-4">
                        {this.state.editingJob ? (
                            <>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("work_order")}</label>
                                    <div>{this.state.editingJob.id}</div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("title")}</label>
                                    <div>{this.state.editingJob.title}</div>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-bold">{t("customer")}</label>
                                    <div>{this.state.editingJob.customer}</div>
                                </div>
                                <div className="row g-3">
                                    <div className="col-12">
                                        <label className="form-label fw-bold">{t("scheduled_date")}</label>
                                        <DatePicker type="th" className="form-control" value={this.state.editStartDate} onChange={(val) => this.setState({ editStartDate: val })} />
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label fw-bold">{t("technician")}</label>
                                        <Select
                                            className="form-control"
                                            options={this.state.technicians.map((tech) => ({ value: tech.uid, label: tech.name }))}
                                            value={this.state.editTechnicianUid}
                                            onChange={(value) => this.setState({ editTechnicianUid: value })}
                                            placeholder={t("choose_technician")}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </Modal.Body>
                    <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-between align-items-center">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.closeEditModal}>
                            {t("cancel")}
                        </button>
                        <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold" onClick={this.saveEditModal}>
                            {t("update")}
                        </button>
                    </Modal.Footer>
                </Modal>

                {/* Schedule Grid Section */}
                <div className="bg-white rounded-4 shadow-sm mb-4 border border-light overflow-hidden">
                    <div className="table-responsive">
                        <table className="table table-bordered mb-0 text-center align-middle" style={{ tableLayout: "fixed", minWidth: "1000px" }}>
                            <thead>
                                <tr>
                                    <th className="bg-white py-3 text-start ps-4 wpx-200 border-0 border-bottom border-end">{t("technician")}</th>
                                    {scheduleDays.map((day, idx) => (
                                        <th key={idx} className={`py-3 border-0 border-bottom border-end ${day.isToday ? "bg-primary-light" : "bg-white"}`}>
                                            <div className={`fw-bold text-14 ${day.isToday ? "text-primary" : "text-dark"}`}>
                                                {day.day} {day.date}
                                            </div>
                                            {day.sub && <div className={`text-12 fw-normal ${day.isToday ? "text-primary" : "text-secondary"}`}>{day.sub}</div>}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {technicians.map((tech, idx) => (
                                    <tr key={idx}>
                                        <td className="text-start ps-3 py-3 border-end bg-white">
                                            <div className="d-flex align-items-center mb-2">
                                                <div
                                                    className="wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold text-14 flex-shrink-0 me-3"
                                                    style={{ backgroundColor: tech.bg }}
                                                >
                                                    {tech.initials}
                                                </div>
                                                <div className="overflow-hidden">
                                                    <div className="fw-bold text-dark text-14 text-truncate">{tech.name}</div>
                                                    <div className="text-secondary text-10 text-wrap lh-sm mt-1">{tech.skills}</div>
                                                </div>
                                            </div>
                                            {tech.isLeave ? (
                                                <span className="badge bg-danger-light text-danger border border-danger-light text-10 px-2 py-1">{tech.leaveText}</span>
                                            ) : (
                                                <div className="d-flex gap-2">
                                                    <span className="badge bg-success-light text-success text-10 px-2 py-1">{tech.jobsCount}</span>
                                                    <span className="badge text-10 px-2 py-1" style={{ backgroundColor: tech.utilBg, color: tech.utilColor }}>
                                                        {tech.utilText}
                                                    </span>
                                                </div>
                                            )}
                                        </td>

                                        {tech.isLeave ? (
                                            <td colSpan={7} className="bg-danger-light border-end py-4">
                                                <div className="text-danger fw-bold text-14 d-flex justify-content-center align-items-center">
                                                    <span className="icon me-2">{"\uf073"}</span> {tech.leaveDate}
                                                </div>
                                            </td>
                                        ) : (
                                            scheduleDays.map((day, dIdx) => {
                                                const jobs = tech.schedule[day.fullDate];
                                                const isWeekend = day.isWeekend;

                                                if (isWeekend) {
                                                    return (
                                                        <td key={dIdx} className="bg-light border-end py-4 text-muted text-12">
                                                            {t("off")}
                                                        </td>
                                                    );
                                                }

                                                return (
                                                    <td
                                                        key={dIdx}
                                                        className="border-end p-2 align-top bg-white"
                                                        onDragOver={this.handleDragOver}
                                                        onDrop={(event) => this.handleDrop(event, tech.uid, day.fullDate, day.fullDate)}
                                                    >
                                                        {jobs ? (
                                                            <div className="d-flex flex-column gap-2">
                                                                {jobs.map((job, jIdx) => (
                                                                    <div
                                                                        key={jIdx}
                                                                        className="text-start p-2 rounded-2 shadow-sm"
                                                                        style={
                                                                            job.customColor
                                                                                ? { backgroundColor: job.customColor, color: job.customTextColor || "#fff", cursor: "pointer" }
                                                                                : { cursor: "pointer" }
                                                                        }
                                                                        onClick={() => this.openEditModal(job)}
                                                                    >
                                                                        <div className="fw-bold text-12 text-truncate">
                                                                            {job.time} - {job.title}
                                                                        </div>
                                                                        <div className="text-10 text-truncate opacity-75">{job.customer}</div>
                                                                    </div>
                                                                ))}
                                                                <div
                                                                    className="border rounded-2 p-1 text-center pointer text-secondary text-10"
                                                                    style={{ borderStyle: "dashed !important", backgroundColor: "#f8f9fa" }}
                                                                >
                                                                    {t("add")}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="h-100 d-flex align-items-center justify-content-center">
                                                                <div
                                                                    className="border rounded-3 w-100 d-flex align-items-center justify-content-center text-secondary text-12"
                                                                    style={{ minHeight: "80px", borderStyle: "dashed !important", backgroundColor: "#fcfcfc" }}
                                                                >
                                                                    {t("drop_job_here")}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>
                                                );
                                            })
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* AI Scheduling Suggestions Panel */}
                {/* <div className="rounded-4 p-4 text-white" style={{ backgroundColor: "#1d4ed8" }}>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div>
                <h5 className="fw-bold mb-1 d-flex align-items-center">
                  <span className="icon me-2">{"\uf044"}</span> {t("ai_scheduling_suggestions")}
                </h5>
                <div className="text-12" style={{ color: "#bfdbfe" }}>
                  {t("ai_suggestions_desc")}
                </div>
              </div>
              <button className="btn btn-sm text-white border border-white-light d-flex align-items-center rounded-3 px-3" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                <span className="icon me-2">{"\uf021"}</span> {t("refresh")}
              </button>
            </div>

            <div className="d-flex flex-column gap-2">
              {aiSuggestions.map((sug, idx) => (
                <div key={idx} className="d-flex justify-content-between align-items-center rounded-3 p-3 border border-white" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                  <div>
                    <div className="fw-bold text-14 mb-1">{sug.wo}</div>
                    <div className="text-12" style={{ color: "#e2e8f0" }}>{sug.desc}</div>
                  </div>
                  <button className="btn btn-white bg-white text-dark fw-bold btn-sm px-4 rounded-pill">
                    {t("apply")}
                  </button>
                </div>
              ))}
            </div>
          </div> */}
            </div>
        </div>
    );
  }
}
